import { useEffect, useState } from 'react';
import { message, Button, Spin, Table, Upload } from 'antd';
import {
  queryAppApi,
  submitAppApi,
  deleteAppApi,
  getProjectApi,
  getEnterpriseInfoApi,
  listScenes,
  MPAppScene,
  getAppInfoByAppIdApi,
} from '@/services/addApp';
import AppProjectModal from './appProjectModal';
import AppIndependentModal from './appIndependentModal';
import { Upload as UploadIcon } from 'patternx-svg';
import { wrapperUrlWithPrefix } from '@/utils/utils';
import upload from '@/utils/uploadFile';
import AppChargeUsageModal from './appChargeUsage';

interface Option {
  appType: number; // 应用类型
}

/**
 * 应用列表
 * @param props
 * @returns
 */
const AppList = (props: Option) => {
  const { appType } = props;
  const [data, setData] = useState<any>([]);
  const [appModalData, setAppModalData] = useState({});
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('新建应用');
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(20); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量
  const [filePrefix, setFilePrefix] = useState('');
  const [chargeVisible, setChargeVisible] = useState(false);

  const editApp = (record: any) => {
    setAppModalData(record);
    setVisible(true);
    setTitle('编辑应用');
  };
  const deleteApp = async (record: any) => {
    const res = await deleteAppApi(record.appId);
    if (res.success) {
      message.success(`删除应用成功`);
      setVisible(false);
      getAppList({ page, pageSize: size });
    }
  };
  let columns = [
    {
      title: '应用名称',
      dataIndex: 'appName',
    },
    {
      title: 'APPID',
      dataIndex: 'appId',
    },
    {
      title: 'appSecret',
      dataIndex: 'appSecret',
      render: function (text: string) {
        return <span>{text.substring(0, text.length - 10) + '*********'}</span>;
      },
    },
    {
      title: '验证文件',
      dataIndex: 'validationFile',
      width: 150,
      render: function (text: string) {
        // return <span>{text && text !== '[]' && JSON.parse(text)[0]?.name}</span>;
        return text && text !== '[]' ? (
          <a href={`${filePrefix}${JSON.parse(text)[0]?.name}`}>{JSON.parse(text)[0]?.name}</a>
        ) : (
          <span>{text}</span>
        );
      },
    },
    {
      title: '场景',
      dataIndex: 'sceneName',
    },
    {
      title: '企业',
      dataIndex: 'enterpriseName',
    },
    {
      title: '项目',
      dataIndex: 'projectName',
    },
    {
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: any) => {
        return (
          <div>
            <Button type="link" onClick={() => editApp(record)}>
              编辑
            </Button>
            {/* <Popconfirm
                title={'确定删除吗?'}
                onConfirm={() => deleteApp(record)}
                key="stop"
            >
                <Button style={{color: 'red'}} type="link">删除</Button>
            </Popconfirm> */}
            <Button
              type="link"
              style={{ color: 'green' }}
              onClick={() => getAppPhoneVerifyUsage(record)}
            >
              手机快速验证用量情况
            </Button>
          </div>
        );
      },
    },
  ];
  if (appType !== 1) {
    columns = columns.filter(
      (item) => item.dataIndex !== 'enterpriseName' && item.dataIndex !== 'projectName',
    );
  }

  const getAppInfo = async (appId: string) => {
    if (appId) {
      const res = await getAppInfoByAppIdApi(appId);
      if (res?.data?.details && res?.data?.code === 'SUCCESS') {
        setFilePrefix(res?.data?.details?.filePrefix);
      }
    }
  };

  const getAppList = async (params: any) => {
    setIsLoading(true);
    const res = await queryAppApi({ ...params, type: appType, query: '' });
    if (res?.data?.code === 'SUCCESS') {
      const dataList: Array<any> = res?.data?.details.data;
      getAppInfo(dataList[0]?.appId);
      // 补充项目、企业信息
      if (appType === 1) {
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            const projectInfoRes: any = await getProjectApi(dataList[i].projectId);
            const projectName = projectInfoRes?.data?.projectName;
            const enterpriseInfo = await getEnterpriseInfoApi(dataList[i].enterpriseId);
            const enterpriseName = enterpriseInfo?.data?.name;
            dataList[i] = Object.assign(dataList[i], {
              projectName: projectName,
              enterpriseName: enterpriseName,
            });
          }
        }
      }
      // 补充场景名称
      const sceneList: any = await listScenes();
      if (sceneList) {
        for (let i = 0; i < dataList.length; i++) {
          const sceneCode = dataList[i].sceneCode;
          const findScene = sceneList.filter(
            (item: MPAppScene) => item.value.toLowerCase() === sceneCode.toLowerCase(),
          );
          if (findScene && findScene.length > 0) {
            dataList[i] = Object.assign(dataList[i], {
              sceneName: findScene[0].label,
            });
          }
        }
      }
      setIsLoading(false);
      setData(dataList);
      setTotal(res?.data?.details?.total);
    }
  };
  useEffect(() => {
    getAppList({ page, pageSize: size, appType: appType });
  }, []);
  const addApp = () => {
    setVisible(true);
    setAppModalData({});
    setTitle('新建应用');
  };
  const handleSubmit = async (values: any) => {
    const res = await submitAppApi(values);
    console.log(res);
    if (res.success) {
      message.success(`${title}成功`);
      setVisible(false);
      getAppList({ page, pageSize: size });
    }
  };
  const handleCancel = () => setVisible(false);

  const onFileChange = ({ file }: any) => {
    if (file?.response && file.response.code === 'SUCCESS') {
      message.success(`文件【${file.response.details}】上传成功`);
    }
  };

  const getAppPhoneVerifyUsage = async (record: any) => {
    console.log('x====', record);
    setAppModalData(record);
    setChargeVisible(true);
  };

  return (
    <div className="app-binding-wrap">
      <div className="btn-wrap">
        <Upload
          key="uploadValidate"
          name="file"
          accept=".txt"
          action={`${wrapperUrlWithPrefix('/account/v1/mpApp/file')}`}
          showUploadList={false}
          onChange={onFileChange}
          customRequest={upload}
        >
          <div className="uploadBtn" style={{ marginRight: `16px` }}>
            <UploadIcon size={20} className="uploadIcon" />
            上传其他小程序验证文件
          </div>
        </Upload>
        <Button onClick={addApp} type="primary">
          添加
        </Button>
      </div>
      <Spin spinning={isLoading}>
        <div className="btn-content">
          <Table
            columns={columns}
            dataSource={data}
            rowKey={(record: any) => record.appId}
            pagination={{
              size: 'small',
              showTotal: (total, range) => {
                return `${range[0]}-${range[1]}条，共${total}条`;
              },
              showTitle: true,
              showQuickJumper: false,
              showSizeChanger: true,
              total: total, // 分页总数
              pageSize: size, // 每页数量
              current: page, // 当前页数
              onChange: (p, s) => {
                setPage(p);
                setSize(s as number);
                getAppList({
                  page: p,
                  pageSize: s,
                });
              },
            }}
            scroll={{ x: true, y: 'calc(100vh - 340px)' }}
          />
        </div>
      </Spin>
      {visible && appType === 0 && (
        <AppIndependentModal
          title={title}
          visible={visible}
          onHandleCancel={handleCancel}
          onHandleSubmit={handleSubmit}
          data={appModalData}
          appType={appType}
        />
      )}
      {visible && appType === 1 && (
        <AppProjectModal
          title={title}
          visible={visible}
          onHandleCancel={handleCancel}
          onHandleSubmit={handleSubmit}
          data={appModalData}
          appType={appType}
        />
      )}
      {chargeVisible && (
        <AppChargeUsageModal
          chargeVisible={chargeVisible}
          appInfo={appModalData}
          setChargeVisible={setChargeVisible}
        />
      )}
    </div>
  );
};

export default AppList;
